<template>
  <div class="app-wrapper" :class="{ hideSidebar: !sidebar.opened }">
    <div class="sidebar-wrapper">
      <sidebar class="sidebar-container" />
    </div>
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <navbar />
      <tags-view />
      <app-main />
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView } from './components'
import { mapState } from 'vuex'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    ...mapState({
      needTagsView: state => state.settings.tagsViews
    })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../src/styles/mixin.scss';

.app-wrapper {
  @include clearFix;
  position: relative;
  height: 100%;
  width: 100%;
  &.hideSidebar {
    .sidebar-wrapper {
      transform: translate(-140px, 0);
      .sidebar-container {
        transform: translate(132px, 0);
      }
      &:hover {
        transform: translate(0, 0);
        .sidebar-container {
          transform: translate(0, 0);
        }
      }
    }
    .main-container {
      margin-left: 40px;
    }
  }
  .sidebar-wrapper {
    width: 180px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
    transition: all 0.28s ease-out;
  }
  .sidebar-container {
    transition: all 0.28s ease-out;
    position: absolute;
    bottom: 0;
    left: 0;
    right: -17px;
    overflow-y: scroll;
  }
  .main-container {
    min-height: 100%;
    transition: all 0.28s ease-out;
    margin-left: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue